import { render } from "./AddQuestion.vue?vue&type=template&id=699392da&scoped=true&ts=true"
import script from "./AddQuestion.vue?vue&type=script&lang=ts"
export * from "./AddQuestion.vue?vue&type=script&lang=ts"

import "./AddQuestion.vue?vue&type=style&index=0&id=699392da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-699392da"]])

export default __exports__